import { Suspense } from 'react';
import { Title } from './Title';
import InnerNavbar from './InnerNavbar';

interface IContent {
    children: JSX.Element;
}

export function Content({ children }: IContent) {
    return (
        <div className=" w-full flex flex-col overflow-hidden h-full relative">
            <Suspense
                fallback={
                    <div className="w-full mt-10 max-xsm:mt-6 sm:mt-12 px-8 max-msm:px-4 sm:px-12">
                        <p className="text-lg w-36 h-6 bg-primary/20 rounded-lg animate-pulse"></p>
                    </div>
                }
            >
                <div className="flex items-center pb-4">
                    <Title />
                    <InnerNavbar />
                </div>
            </Suspense>
            {children}
        </div>
    );
}
